import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import mediaQueries from 'syf-component-library/const/mediaQueries';
import { RenderIf } from 'syf-component-library/ui/atoms';
import { getPromotions, getPromotionsFilteredData } from '../../helpers/promotions-utils';
import usePromotionsQuery from '../../services/promotions/promotions-query';
import Viewport from '../common/viewport/viewport';
import APIError from './api-error';
import Desktop from './desktop';
import Loader from './loader';
import Mobile from './mobile';
import ModalDetails from './modal-details';
import NoPromotions from './no-promotions';
const Promotions = ({ config, accountId, accountIdType }) => {
    const { data, isError, isSuccess, isLoading } = usePromotionsQuery({
        config,
        keyProps: { accountId, accountIdType }
    });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedPromotion, setSelectedPromotion] = useState(null);
    const closeDetailsModal = () => setIsModalOpen(false);
    const showDetailsModal = (promotion) => {
        setSelectedPromotion(promotion);
        setIsModalOpen(true);
    };
    const { active, expired } = getPromotionsFilteredData(getPromotions(data));
    const hasPromotions = active.length !== 0 || expired.length !== 0;
    return (_jsxs(_Fragment, { children: [_jsx(RenderIf, { condition: isLoading, children: _jsx(Loader, {}) }), _jsx(RenderIf, { condition: isError, children: _jsx(APIError, {}) }), _jsx(RenderIf, { condition: !isError, children: _jsxs(_Fragment, { children: [_jsx(RenderIf, { condition: !hasPromotions && isSuccess, children: _jsx(NoPromotions, {}) }), _jsx(RenderIf, { condition: hasPromotions, children: _jsxs(_Fragment, { children: [_jsx(Viewport.Desktop, { query: mediaQueries.greaterThanLarge, children: _jsx(Desktop, { activePromotions: active, expiredPromotions: expired, showDetailsModal: showDetailsModal, isModalOpen: isModalOpen }) }), _jsx(Viewport.Mobile, { query: mediaQueries.lessThanLarge, children: _jsx(Mobile, { activePromotions: active, expiredPromotions: expired, showDetailsModal: showDetailsModal, isModalOpen: isModalOpen }) })] }) })] }) }), _jsx(RenderIf, { condition: Boolean(selectedPromotion && isModalOpen), children: _jsx(ModalDetails, { closeModal: closeDetailsModal, open: isModalOpen, promotion: selectedPromotion }) })] }));
};
export default Promotions;
//# sourceMappingURL=index.js.map